import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import { withNamespaces } from "react-i18next";

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    fontFamily: "Poppins",
    cursor: "pointer",
    textDecoration: "none",
  },
  cardImage: {
    width: "100%",
    borderRadius: "8px",
    objectFit: "cover",
  },
  descriptionContainer: {
    width: "100%",

    padding: "16px 8px",
  },
  title: {
    fontWeight: "600",
    fontSize: "1.2rem",
    color: theme?.colors?.aboutCard?.title,
    margin: "0",
  },
  description: {
    fontSize: "1rem",
    color: "#A0A0A0",
    margin: "8px 0 0 0",
  },
});

const howToArticleCard = ({
  styles,
  descriptionContainerStyles,
  classes,
  image,
  href,
  title,
  description,
}) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.root}
    >
      <img
        style={{ ...styles }}
        className={classes.cardImage}
        src={image}
        alt=""
      />
      <div
        className={classes.descriptionContainer}
        style={{ ...descriptionContainerStyles }}
      >
        <p className={classes.title}>{title}</p>
        {description && <p className={classes.description}>{description}</p>}
      </div>
    </a>
  );
};

export default withNamespaces()(
  withRouter(withStyles(styles)(howToArticleCard))
);
